/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface CreateChatSessionDto {
  /**
   * 세션 제목 / Session title
   * @example "KPC 프롬프트 시험 대화"
   */
  title: string;
  /**
   * 세션 설명 / Session description
   * @example "KPC 프롬프트 활용 온라인 시험을 위한 AI 챗봇 대화"
   */
  description?: string;
  /**
   * 세션 설정 / Session settings
   * @example {"temperature":0.7,"maxTokens":1000}
   */
  settings?: object;
}

export interface ApiResponseDto {
  /** 성공 여부 / Success status */
  success: boolean;
  /** 응답 메시지 / Response message */
  message: string;
  /** 응답 데이터 / Response data */
  data: object;
  /** 에러 코드 / Error code */
  errorCode?: string;
  /** 타임스탬프 / Timestamp */
  timestamp: string;
}

export interface PaginatedResponseDto {
  /** 성공 여부 / Success status */
  success: boolean;
  /** 응답 메시지 / Response message */
  message: string;
  /** 응답 데이터 / Response data */
  data: object;
  /** 에러 코드 / Error code */
  errorCode?: string;
  /** 타임스탬프 / Timestamp */
  timestamp: string;
  /** 페이지네이션 정보 / Pagination info */
  pagination: object;
}

export interface SendMessageDto {
  /**
   * 채팅 세션 ID / Chat session ID
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  sessionId: string;
  /**
   * 메시지 내용 / Message content
   * @example "안녕하세요! KPC 프롬프트 시험에 대해 알려주세요."
   */
  content: string;
  /**
   * 메시지 메타데이터 / Message metadata
   * @example {"source":"web","timestamp":"2024-01-01T00:00:00Z"}
   */
  metadata?: object;
}

export interface ChatMessageDto {
  /**
   * Message role (user, assistant, system)
   * @example "user"
   */
  role: "user" | "assistant" | "system";
  /**
   * Message content
   * @example "안녕하세요! 간단한 인사말을 해주세요."
   */
  content: string;
}

export interface ChatRequestDto {
  /**
   * Array of chat messages
   * @example [{"role":"user","content":"안녕하세요! 간단한 인사말을 해주세요."}]
   */
  messages: ChatMessageDto[];
  /**
   * Maximum number of tokens to generate (512-10000)
   * @min 512
   * @max 10000
   * @default 8196
   * @example 8196
   */
  max_tokens: number;
  /**
   * Temperature for response generation (0.0-1.0)
   * @min 0
   * @max 1
   * @default 0.5
   * @example 0.5
   */
  temperature: number;
  /**
   * Top-p sampling parameter (0.0-1.0)
   * @min 0
   * @max 1
   * @default 0.9
   * @example 0.9
   */
  top_p: number;
}

export interface ChatStatsDto {
  /**
   * Response text length in characters
   * @example 83
   */
  length: number;
  /**
   * Number of tokens used
   * @example 512
   */
  tokens: number;
}

export interface ChatResponseDto {
  /**
   * AI generated response message
   * @example "안녕하세요! 만나서 반갑습니다. 오늘 어떤 도움이 필요하신가요?"
   */
  message: string;
  /** Response statistics */
  stats?: ChatStatsDto;
}

export interface GenerateImageDto {
  /**
   * 이미지 생성 프롬프트 / Image generation prompt
   * @example "A beautiful landscape with mountains and a lake at sunset"
   */
  prompt: string;
  /**
   * 이미지 크기 / Image size
   * @default "1024x1024"
   */
  size?: "256x256" | "512x512" | "1024x1024";
  /**
   * 이미지 품질 / Image quality
   * @default "standard"
   */
  quality?: "standard" | "hd";
  /**
   * 생성할 이미지 수 / Number of images to generate
   * @min 1
   * @max 4
   * @default 1
   */
  n?: number;
  /**
   * 생성 모델 / Generation model
   * @example "dall-e-3"
   */
  model?: string;
}

export interface CreateEmbeddingDto {
  /**
   * 임베딩할 텍스트 내용 / Text content to embed
   * @example "KPC 프롬프트 엔지니어링 시험에 대한 정보"
   */
  content: string;
  /**
   * 콘텐츠 타입 / Content type
   * @example "document"
   */
  contentType: string;
  /**
   * 콘텐츠 ID / Content ID
   * @example "doc-001"
   */
  contentId: string;
  /**
   * 임베딩 모델 / Embedding model
   * @default "text-embedding-ada-002"
   * @example "text-embedding-ada-002"
   */
  model?: string;
  /**
   * 메타데이터 / Metadata
   * @example {"source":"kpc-document","category":"exam-info"}
   */
  metadata?: object;
}

export interface SearchEmbeddingDto {
  /**
   * 검색 쿼리 / Search query
   * @example "프롬프트 엔지니어링 시험 방법"
   */
  query: string;
  /**
   * 콘텐츠 타입 필터 / Content type filter
   * @example "document"
   */
  contentType?: string;
  /**
   * 검색 결과 수 제한 / Limit number of search results
   * @min 1
   * @max 100
   * @default 10
   */
  limit?: number;
  /**
   * 유사도 임계값 / Similarity threshold
   * @min 0
   * @max 1
   * @default 0.7
   */
  threshold?: number;
}

export interface AdminLoginDto {
  /**
   * 관리자 사용자명 / Admin username
   * @example "admin"
   */
  username: string;
  /**
   * 비밀번호 / Password
   * @example "I4SjlgLd7W4"
   */
  password: string;
}

export interface AdminLoginResponseDto {
  /** JWT 토큰 / JWT token */
  access_token: string;
  /** 사용자 정보 / User information */
  user: object;
}

export interface CreateAdminUserDto {
  /**
   * 관리자 사용자명 / Admin username
   * @example "admin2"
   */
  username: string;
  /**
   * 비밀번호 / Password
   * @minLength 8
   * @example "Password123!"
   */
  password: string;
  /**
   * 관리자 역할 / Admin role
   * @example "NORMAL"
   */
  role: "SUPER" | "NORMAL";
  /** 이름 / Name */
  name?: string;
  /** 이메일 / Email */
  email?: string;
}

export interface UpdateAdminUserDto {
  /**
   * 비밀번호 / Password
   * @minLength 8
   */
  password?: string;
  /** 관리자 역할 / Admin role */
  role?: "SUPER" | "NORMAL";
  /** 활성 상태 / Active status */
  isActive?: boolean;
  /** 이름 / Name */
  name?: string;
  /** 이메일 / Email */
  email?: string;
}

export interface CreateConfigDto {
  /**
   * 설정 키 / Configuration key
   * @example "maxTokens"
   */
  key: string;
  /**
   * 설정 값 / Configuration value
   * @example "8196"
   */
  value: string;
  /** 설정 설명 / Configuration description */
  description?: string;
}

export interface UpdateConfigDto {
  /** 설정 값 / Configuration value */
  value?: string;
  /** 설정 설명 / Configuration description */
  description?: string;
}

export interface DashboardStatsDto {
  /** 전체 텍스트 생성 로그 수 */
  totalTextLogs: number;
  /** 전체 이미지 생성 로그 수 */
  totalImageLogs: number;
  /** 오늘 생성된 텍스트 로그 수 */
  todayTextLogs: number;
  /** 오늘 생성된 이미지 로그 수 */
  todayImageLogs: number;
  /** 활성 사용자 수 (고유 userId 수) */
  activeUsers: number;
  /** 총 입력 토큰 */
  totalInputTokens: number;
  /** 총 출력 토큰 */
  totalOutputTokens: number;
  /** 총 토큰 */
  totalTokens: number;
}

export interface LogStatsByDateDto {
  /** 날짜 (YYYY-MM-DD 형식) */
  date: string;
  /** 텍스트 생성 로그 수 */
  textLogs: number;
  /** 이미지 생성 로그 수 */
  imageLogs: number;
}

export interface TopUserStatsDto {
  /** 사용자 ID */
  userId: string;
  /** 텍스트 생성 로그 수 */
  textLogCount: number;
  /** 이미지 생성 로그 수 */
  imageLogCount: number;
  /** 전체 로그 수 */
  totalLogCount: number;
}

export interface TopExperimentKeyStatsDto {
  /** 실험 키 */
  experimentKey: string;
  /** 텍스트 생성 로그 수 */
  textLogCount: number;
  /** 이미지 생성 로그 수 */
  imageLogCount: number;
  /** 전체 로그 수 */
  totalLogCount: number;
}

export interface TokenUsageStatsDto {
  /** 총 입력 토큰 */
  totalInputTokens: number;
  /** 총 출력 토큰 */
  totalOutputTokens: number;
  /** 총 토큰 */
  totalTokens: number;
  /** 평균 입력 토큰 */
  avgInputTokens: number;
  /** 평균 출력 토큰 */
  avgOutputTokens: number;
  /** 평균 토큰 */
  avgTokens: number;
  /** 최대 입력 토큰 */
  maxInputTokens: number;
  /** 최대 출력 토큰 */
  maxOutputTokens: number;
  /** 최대 토큰 */
  maxTokens: number;
  /** 최소 입력 토큰 */
  minInputTokens: number;
  /** 최소 출력 토큰 */
  minOutputTokens: number;
  /** 최소 토큰 */
  minTokens: number;
}

export interface RecentActivityDto {
  /** 활동 ID */
  id: string;
  /** 활동 타입 (text 또는 image) */
  type: string;
  /** 사용자 ID */
  userId: string;
  /** 실험 키 */
  experimentKey: string;
  /**
   * 생성일시
   * @format date-time
   */
  createdAt: string;
  /** 추가 정보 (텍스트: 프롬프트 미리보기, 이미지: imageUrl) */
  preview: string;
}

export interface TextGenerationDto {
  /**
   * Text generation prompt (max 3000 characters)
   * @maxLength 3000
   * @example "KPC 프롬프트 엔지니어링 시험에 대해 설명해주세요."
   */
  prompt: string;
  /**
   * Image or file URLs for multimodal generation (optional)
   * @example ["https://cdn.tacoworks.ai/kpc-upload/image1.jpg","https://cdn.tacoworks.ai/kpc-upload/document.pdf"]
   */
  imageUrls?: string[];
}

export interface ImageGenerationDto {
  /**
   * Image generation prompt
   * @example "KPC 로고가 있는 현대적인 사무실 건물"
   */
  prompt: string;
}

export interface TranslateKoToEnDto {
  /**
   * Korean text to translate to English (max 3000 characters)
   * @maxLength 3000
   * @example "안녕하세요, 오늘 날씨가 정말 좋네요."
   */
  text: string;
}

export interface ConfigLimitsDto {
  /**
   * Maximum prompt length for text generation
   * @example 3000
   */
  textMaxPromptLength: number;
  /**
   * Maximum prompt length for image generation
   * @example 3000
   */
  imageMaxPromptLength: number;
  /**
   * Maximum output length for translation
   * @example 3000
   */
  translationMaxOutputLength: number;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title KPC AI POT 2025 API
 * @version 1.0
 * @contact
 *
 * KPC 프롬프트 시험용 임베딩 AI 도구 API 문서
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  chat = {
    /**
     * @description 새로운 채팅 세션을 생성합니다 / Creates a new chat session
     *
     * @tags chat - AWS Nova
     * @name ChatControllerCreateSession
     * @summary Create new chat session
     * @request POST:/chat/sessions
     */
    chatControllerCreateSession: (
      data: CreateChatSessionDto,
      params: RequestParams = {},
    ) =>
      this.request<ApiResponseDto, any>({
        path: `/chat/sessions`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 사용자의 채팅 세션 목록을 조회합니다 / Gets user chat sessions
     *
     * @tags chat - AWS Nova
     * @name ChatControllerGetUserSessions
     * @summary Get user chat sessions
     * @request GET:/chat/sessions
     */
    chatControllerGetUserSessions: (
      query?: {
        /**
         * 페이지 번호 / Page number
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * 페이지당 항목 수 / Items per page
         * @min 1
         * @max 100
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedResponseDto, any>({
        path: `/chat/sessions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description ID로 채팅 세션을 조회합니다 / Gets chat session by ID
     *
     * @tags chat - AWS Nova
     * @name ChatControllerGetSession
     * @summary Get chat session by ID
     * @request GET:/chat/sessions/{id}
     */
    chatControllerGetSession: (id: string, params: RequestParams = {}) =>
      this.request<ApiResponseDto, any>({
        path: `/chat/sessions/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 채팅 세션을 삭제합니다 / Deletes a chat session
     *
     * @tags chat - AWS Nova
     * @name ChatControllerDeleteSession
     * @summary Delete chat session
     * @request DELETE:/chat/sessions/{id}
     */
    chatControllerDeleteSession: (id: string, params: RequestParams = {}) =>
      this.request<ApiResponseDto, any>({
        path: `/chat/sessions/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description 채팅에 메시지를 전송합니다 / Sends a message to chat
     *
     * @tags chat - AWS Nova
     * @name ChatControllerSendMessage
     * @summary Send message to chat
     * @request POST:/chat/messages
     */
    chatControllerSendMessage: (
      data: SendMessageDto,
      params: RequestParams = {},
    ) =>
      this.request<ApiResponseDto, any>({
        path: `/chat/messages`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Nova Pro 모델과 JSON 형식으로 채팅합니다 / Chat with Nova Pro model using JSON format
     *
     * @tags chat - AWS Nova
     * @name ChatControllerChatWithNovaPro
     * @summary Nova Pro Chat - matches Python FastAPI endpoint
     * @request POST:/chat/api/chat
     */
    chatControllerChatWithNovaPro: (
      data: ChatRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<ChatResponseDto, void>({
        path: `/chat/api/chat`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 텍스트 및 이미지 파일을 포함한 Nova Pro 채팅 / Nova Pro chat with text and image file support
     *
     * @tags chat - AWS Nova
     * @name ChatControllerChatWithFileUpload
     * @summary Nova Pro Chat with File Upload - matches Python FastAPI endpoint
     * @request POST:/chat/api/chat/upload
     */
    chatControllerChatWithFileUpload: (
      data: {
        /**
         * JSON string of chat messages array
         * @example "[{"role":"user","content":"이미지를 분석해주세요"}]"
         */
        messages: string;
        /**
         * Maximum tokens (512-10000)
         * @example 8196
         */
        maxTokens?: number;
        /**
         * Temperature (0.0-1.0)
         * @example 0.5
         */
        temperature?: number;
        /**
         * Top-p (0.0-1.0)
         * @example 0.9
         */
        topP?: number;
        /**
         * Optional file upload (text/plain, image/jpeg, image/png)
         * @format binary
         */
        file?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChatResponseDto, void>({
        path: `/chat/api/chat/upload`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),
  };
  image = {
    /**
     * @description AI를 사용하여 이미지를 생성합니다 / Generates an image using AI
     *
     * @tags image - AWS Nova
     * @name ImageControllerGenerateImage
     * @summary Generate AI image
     * @request POST:/image/generate
     */
    imageControllerGenerateImage: (
      data: GenerateImageDto,
      params: RequestParams = {},
    ) =>
      this.request<ApiResponseDto, any>({
        path: `/image/generate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 이미지 생성 히스토리를 조회합니다 / Gets image generation history
     *
     * @tags image - AWS Nova
     * @name ImageControllerGetImageHistory
     * @summary Get image generation history
     * @request GET:/image/history
     */
    imageControllerGetImageHistory: (
      query?: {
        /**
         * 페이지 번호 / Page number
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * 페이지당 항목 수 / Items per page
         * @min 1
         * @max 100
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedResponseDto, any>({
        path: `/image/history`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description ID로 이미지를 조회합니다 / Gets image by ID
     *
     * @tags image - AWS Nova
     * @name ImageControllerGetImage
     * @summary Get image by ID
     * @request GET:/image/{id}
     */
    imageControllerGetImage: (id: string, params: RequestParams = {}) =>
      this.request<ApiResponseDto, any>({
        path: `/image/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 이미지를 삭제합니다 / Deletes an image
     *
     * @tags image - AWS Nova
     * @name ImageControllerDeleteImage
     * @summary Delete image
     * @request DELETE:/image/{id}
     */
    imageControllerDeleteImage: (id: string, params: RequestParams = {}) =>
      this.request<ApiResponseDto, any>({
        path: `/image/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),
  };
  embedding = {
    /**
     * @description 텍스트에 대한 임베딩을 생성합니다 / Creates an embedding for text
     *
     * @tags embedding - AWS Titan (Deprecated)
     * @name EmbeddingControllerCreateEmbedding
     * @summary Create embedding
     * @request POST:/embedding
     * @deprecated
     */
    embeddingControllerCreateEmbedding: (
      data: CreateEmbeddingDto,
      params: RequestParams = {},
    ) =>
      this.request<ApiResponseDto, any>({
        path: `/embedding`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 유사한 임베딩을 검색합니다 / Searches for similar embeddings
     *
     * @tags embedding - AWS Titan (Deprecated)
     * @name EmbeddingControllerSearchSimilar
     * @summary Search similar embeddings
     * @request POST:/embedding/search
     * @deprecated
     */
    embeddingControllerSearchSimilar: (
      data: SearchEmbeddingDto,
      params: RequestParams = {},
    ) =>
      this.request<ApiResponseDto, any>({
        path: `/embedding/search`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ID로 임베딩을 조회합니다 / Gets embedding by ID
     *
     * @tags embedding - AWS Titan (Deprecated)
     * @name EmbeddingControllerGetEmbedding
     * @summary Get embedding by ID
     * @request GET:/embedding/{id}
     * @deprecated
     */
    embeddingControllerGetEmbedding: (id: string, params: RequestParams = {}) =>
      this.request<ApiResponseDto, any>({
        path: `/embedding/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 임베딩을 삭제합니다 / Deletes an embedding
     *
     * @tags embedding - AWS Titan (Deprecated)
     * @name EmbeddingControllerDeleteEmbedding
     * @summary Delete embedding
     * @request DELETE:/embedding/{id}
     * @deprecated
     */
    embeddingControllerDeleteEmbedding: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<ApiResponseDto, any>({
        path: `/embedding/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description 콘텐츠로 임베딩을 조회합니다 / Gets embeddings by content
     *
     * @tags embedding - AWS Titan (Deprecated)
     * @name EmbeddingControllerGetEmbeddingsByContent
     * @summary Get embeddings by content
     * @request GET:/embedding/content/{contentType}/{contentId}
     * @deprecated
     */
    embeddingControllerGetEmbeddingsByContent: (
      contentType: string,
      contentId: string,
      params: RequestParams = {},
    ) =>
      this.request<ApiResponseDto, any>({
        path: `/embedding/content/${contentType}/${contentId}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  admin = {
    /**
     * @description 모든 AWS 액세스 키 정보를 조회합니다 / Gets all AWS access key information
     *
     * @tags Admin - AWS Nova Management
     * @name AdminControllerGetAwsKeys
     * @summary Get all AWS access keys
     * @request GET:/admin/aws/keys
     */
    adminControllerGetAwsKeys: (params: RequestParams = {}) =>
      this.request<ApiResponseDto, any>({
        path: `/admin/aws/keys`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description AWS 액세스 키 개수를 조회합니다 / Gets AWS access key count
     *
     * @tags Admin - AWS Nova Management
     * @name AdminControllerGetAwsKeyCount
     * @summary Get AWS access key count
     * @request GET:/admin/aws/keys/count
     */
    adminControllerGetAwsKeyCount: (params: RequestParams = {}) =>
      this.request<ApiResponseDto, any>({
        path: `/admin/aws/keys/count`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 다음 사용할 AWS 액세스 키를 조회합니다 / Gets next AWS access key to use
     *
     * @tags Admin - AWS Nova Management
     * @name AdminControllerGetNextAwsKey
     * @summary Get next AWS access key
     * @request GET:/admin/aws/keys/next
     */
    adminControllerGetNextAwsKey: (params: RequestParams = {}) =>
      this.request<ApiResponseDto, any>({
        path: `/admin/aws/keys/next`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 랜덤한 AWS 액세스 키를 조회합니다 / Gets random AWS access key
     *
     * @tags Admin - AWS Nova Management
     * @name AdminControllerGetRandomAwsKey
     * @summary Get random AWS access key
     * @request GET:/admin/aws/keys/random
     */
    adminControllerGetRandomAwsKey: (params: RequestParams = {}) =>
      this.request<ApiResponseDto, any>({
        path: `/admin/aws/keys/random`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 계정 ID로 AWS 액세스 키를 조회합니다 / Gets AWS access key by account ID
     *
     * @tags Admin - AWS Nova Management
     * @name AdminControllerGetAwsKeyByAccountId
     * @summary Get AWS access key by account ID
     * @request GET:/admin/aws/keys/{accountId}
     */
    adminControllerGetAwsKeyByAccountId: (
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<ApiResponseDto, any>({
        path: `/admin/aws/keys/${accountId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description AWS 연결을 테스트합니다 / Tests AWS connection
     *
     * @tags Admin - AWS Nova Management
     * @name AdminControllerTestAwsConnection
     * @summary Test AWS connection
     * @request POST:/admin/aws/test-connection
     */
    adminControllerTestAwsConnection: (params: RequestParams = {}) =>
      this.request<ApiResponseDto, any>({
        path: `/admin/aws/test-connection`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description 로드 밸런싱 통계를 조회합니다 / Gets load balancing statistics
     *
     * @tags Admin - AWS Nova Management
     * @name AdminControllerGetLoadBalancerStats
     * @summary Get load balancing statistics
     * @request GET:/admin/aws/load-balancer/stats
     */
    adminControllerGetLoadBalancerStats: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/aws/load-balancer/stats`,
        method: "GET",
        ...params,
      }),

    /**
     * @description 다중 리전 로드 밸런싱 통계를 조회합니다 / Gets multi-region load balancing statistics
     *
     * @tags Admin - AWS Nova Management
     * @name AdminControllerGetMultiRegionStats
     * @summary Get multi-region load balancing statistics
     * @request GET:/admin/aws/multi-region/stats
     */
    adminControllerGetMultiRegionStats: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/aws/multi-region/stats`,
        method: "GET",
        ...params,
      }),

    /**
     * @description AWS 계정 통계를 조회합니다 / Gets AWS account statistics
     *
     * @tags Admin - AWS Nova Management
     * @name AdminControllerGetAccountStats
     * @summary Get AWS account statistics
     * @request GET:/admin/aws/accounts/stats
     */
    adminControllerGetAccountStats: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/aws/accounts/stats`,
        method: "GET",
        ...params,
      }),

    /**
     * @description 리전 통계를 조회합니다 / Gets region statistics
     *
     * @tags Admin - AWS Nova Management
     * @name AdminControllerGetRegionStats
     * @summary Get region statistics
     * @request GET:/admin/aws/regions/stats
     */
    adminControllerGetRegionStats: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/aws/regions/stats`,
        method: "GET",
        ...params,
      }),

    /**
     * @description AWS 서비스 헬스 체크를 조회합니다 / Gets AWS services health check
     *
     * @tags Admin - AWS Nova Management
     * @name AdminControllerGetHealthCheck
     * @summary Get AWS services health check
     * @request GET:/admin/aws/health-check
     */
    adminControllerGetHealthCheck: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/aws/health-check`,
        method: "GET",
        ...params,
      }),

    /**
     * @description 특정 계정의 키 상태를 업데이트합니다 / Updates key status for specific account
     *
     * @tags Admin - AWS Nova Management
     * @name AdminControllerUpdateKeyStatus
     * @summary Update key status
     * @request POST:/admin/aws/load-balancer/key/{accountId}/status
     */
    adminControllerUpdateKeyStatus: (
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/admin/aws/load-balancer/key/${accountId}/status`,
        method: "POST",
        ...params,
      }),

    /**
     * @description 특정 계정의 키를 실패로 표시합니다 / Marks key as failed for specific account
     *
     * @tags Admin - AWS Nova Management
     * @name AdminControllerMarkKeyFailed
     * @summary Mark key as failed
     * @request POST:/admin/aws/load-balancer/key/{accountId}/mark-failed
     */
    adminControllerMarkKeyFailed: (
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/admin/aws/load-balancer/key/${accountId}/mark-failed`,
        method: "POST",
        ...params,
      }),

    /**
     * @description 특정 계정의 키를 성공으로 표시합니다 / Marks key as successful for specific account
     *
     * @tags Admin - AWS Nova Management
     * @name AdminControllerMarkKeySuccess
     * @summary Mark key as successful
     * @request POST:/admin/aws/load-balancer/key/{accountId}/mark-success
     */
    adminControllerMarkKeySuccess: (
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/admin/aws/load-balancer/key/${accountId}/mark-success`,
        method: "POST",
        ...params,
      }),
  };
  test = {
    /**
     * @description 사용 가능한 Bedrock 모델 목록 조회 / Get available Bedrock models
     *
     * @tags Test - AWS Nova Model Testing
     * @name TestControllerGetAvailableModels
     * @summary Get available Bedrock models
     * @request GET:/test/available-models
     */
    testControllerGetAvailableModels: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/test/available-models`,
        method: "GET",
        ...params,
      }),

    /**
     * @description AWS Nova Lite를 사용한 텍스트 생성 테스트 / Test text generation using AWS Nova Lite
     *
     * @tags Test - AWS Nova Model Testing
     * @name TestControllerTestTextGeneration
     * @summary Test text generation with AWS Nova Lite
     * @request POST:/test/text-generation
     */
    testControllerTestTextGeneration: (
      data: {
        /**
         * Text generation prompt
         * @example "KPC 프롬프트 엔지니어링 시험에 대해 설명해주세요."
         */
        prompt: string;
        /**
         * Maximum tokens to generate
         * @default 8196
         * @example 8196
         */
        maxTokens?: number;
        /**
         * Temperature for generation
         * @default 0.5
         * @example 0.5
         */
        temperature?: number;
        /**
         * Top-P sampling parameter
         * @default 0.9
         * @example 0.9
         */
        topP?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/test/text-generation`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 고정 설정으로 AWS Nova Pro 모델을 사용한 텍스트 생성 테스트 / Test text generation using AWS Nova Pro with fixed configuration
     *
     * @tags Test - AWS Nova Model Testing
     * @name TestControllerTestNovaProTextGeneration
     * @summary Test text generation with AWS Nova Pro (Fixed Config)
     * @request POST:/test/nova-pro-text-generation
     */
    testControllerTestNovaProTextGeneration: (
      data: {
        /**
         * Text generation prompt
         * @example "KPC 프롬프트 엔지니어링 시험에 대해 설명해주세요."
         */
        prompt: string;
        /**
         * Maximum tokens to generate
         * @default 1000
         * @example 1000
         */
        maxTokens?: number;
        /**
         * Temperature for generation
         * @default 0.7
         * @example 0.7
         */
        temperature?: number;
        /**
         * System prompt for context
         * @example "당신은 KPC의 AI 어시스턴트입니다."
         */
        systemPrompt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/test/nova-pro-text-generation`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 커스텀 설정으로 Nova Pro 모델을 사용한 텍스트 생성 테스트 / Test text generation using Nova Pro with custom configuration
     *
     * @tags Test - AWS Nova Model Testing
     * @name TestControllerTestNovaProCustomConfig
     * @summary Test text generation with custom configuration
     * @request POST:/test/nova-pro-custom-test
     */
    testControllerTestNovaProCustomConfig: (
      data: {
        /**
         * Text generation prompt
         * @example "KPC 프롬프트 엔지니어링 시험에 대해 설명해주세요."
         */
        prompt: string;
        /** Custom configuration */
        config: {
          /** @example "us-east-1" */
          region: string;
          /** @example "us.amazon.nova-pro-v1:0" */
          modelId: string;
          /** @example "arn:aws:bedrock:us-east-1:184601568941:inference-profile/us.amazon.nova-pro-v1:0" */
          modelArn: string;
          /** @example "US Nova Pro" */
          name: string;
          /** @example "184601568941" */
          accountId: string;
          /** @example "AKIATVKHFS3P7MDQXKO2" */
          accessKeyId: string;
          /** @example "gFipnFUCE16vLyR3unKKgZioKHTCbIzS+4KvAeIl" */
          secretAccessKey: string;
        };
        /**
         * Maximum tokens to generate
         * @default 1000
         * @example 1000
         */
        maxTokens?: number;
        /**
         * Temperature for generation
         * @default 0.7
         * @example 0.7
         */
        temperature?: number;
        /**
         * System prompt for context
         * @example "당신은 KPC의 AI 어시스턴트입니다."
         */
        systemPrompt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/test/nova-pro-custom-test`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description AWS Nova Canvas를 사용한 이미지 생성 테스트 / Test image generation using AWS Nova Canvas
     *
     * @tags Test - AWS Nova Model Testing
     * @name TestControllerTestImageGeneration
     * @summary Test image generation with AWS Nova Canvas
     * @request POST:/test/image-generation
     */
    testControllerTestImageGeneration: (
      data: {
        /**
         * Image generation prompt
         * @example "KPC 로고가 있는 현대적인 사무실 건물"
         */
        prompt: string;
        /**
         * Image width
         * @default 512
         * @example 512
         */
        width?: number;
        /**
         * Image height
         * @default 512
         * @example 512
         */
        height?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/test/image-generation`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  api = {
    /**
     * @description 관리자 로그인 / Admin login
     *
     * @tags Admin - Authentication
     * @name AdminAuthControllerLogin
     * @summary Admin login
     * @request POST:/api/admin/auth/login
     */
    adminAuthControllerLogin: (
      data: AdminLoginDto,
      params: RequestParams = {},
    ) =>
      this.request<AdminLoginResponseDto, void>({
        path: `/api/admin/auth/login`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 현재 관리자 사용자 정보 조회 / Get current admin user information
     *
     * @tags Admin - Authentication
     * @name AdminAuthControllerGetMe
     * @summary Get current admin user
     * @request GET:/api/admin/auth/me
     * @secure
     */
    adminAuthControllerGetMe: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/admin/auth/me`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description 모든 관리자 사용자 조회 (슈퍼 관리자만) / Get all admin users (Super only)
     *
     * @tags Admin - Management
     * @name AdminManagementControllerGetAllAdminUsers
     * @summary Get all admin users
     * @request GET:/api/admin/users
     * @secure
     */
    adminManagementControllerGetAllAdminUsers: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/admin/users`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description 관리자 사용자 생성 (슈퍼 관리자만) / Create admin user (Super only)
     *
     * @tags Admin - Management
     * @name AdminManagementControllerCreateAdminUser
     * @summary Create admin user
     * @request POST:/api/admin/users
     * @secure
     */
    adminManagementControllerCreateAdminUser: (
      data: CreateAdminUserDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/admin/users`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description ID로 관리자 사용자 조회 (슈퍼 관리자만) / Get admin user by ID (Super only)
     *
     * @tags Admin - Management
     * @name AdminManagementControllerGetAdminUserById
     * @summary Get admin user by ID
     * @request GET:/api/admin/users/{id}
     * @secure
     */
    adminManagementControllerGetAdminUserById: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/admin/users/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description 관리자 사용자 수정 (슈퍼 관리자만) / Update admin user (Super only)
     *
     * @tags Admin - Management
     * @name AdminManagementControllerUpdateAdminUser
     * @summary Update admin user
     * @request PUT:/api/admin/users/{id}
     * @secure
     */
    adminManagementControllerUpdateAdminUser: (
      id: string,
      data: UpdateAdminUserDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/admin/users/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 관리자 사용자 삭제 (슈퍼 관리자만) / Delete admin user (Super only)
     *
     * @tags Admin - Management
     * @name AdminManagementControllerDeleteAdminUser
     * @summary Delete admin user
     * @request DELETE:/api/admin/users/{id}
     * @secure
     */
    adminManagementControllerDeleteAdminUser: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/admin/users/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description 모든 시스템 사용자 조회 (슈퍼 관리자만) / Get all system users (Super only)
     *
     * @tags Admin - Management
     * @name AdminManagementControllerGetAllSystemUsers
     * @summary Get all system users
     * @request GET:/api/admin/system-users
     * @secure
     */
    adminManagementControllerGetAllSystemUsers: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/admin/system-users`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description ID로 시스템 사용자 조회 (슈퍼 관리자만) / Get system user by ID (Super only)
     *
     * @tags Admin - Management
     * @name AdminManagementControllerGetSystemUserById
     * @summary Get system user by ID
     * @request GET:/api/admin/system-users/{id}
     * @secure
     */
    adminManagementControllerGetSystemUserById: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/admin/system-users/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description 시스템 사용자 수정 (슈퍼 관리자만) / Update system user (Super only)
     *
     * @tags Admin - Management
     * @name AdminManagementControllerUpdateSystemUser
     * @summary Update system user
     * @request PUT:/api/admin/system-users/{id}
     * @secure
     */
    adminManagementControllerUpdateSystemUser: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/admin/system-users/${id}`,
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * @description 시스템 사용자 삭제 (슈퍼 관리자만) / Delete system user (Super only)
     *
     * @tags Admin - Management
     * @name AdminManagementControllerDeleteSystemUser
     * @summary Delete system user
     * @request DELETE:/api/admin/system-users/{id}
     * @secure
     */
    adminManagementControllerDeleteSystemUser: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/admin/system-users/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description 모든 설정 조회 / Get all configs
     *
     * @tags Admin - Management
     * @name AdminManagementControllerGetAllConfigs
     * @summary Get all configs
     * @request GET:/api/admin/configs
     * @secure
     */
    adminManagementControllerGetAllConfigs: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/admin/configs`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description 설정 생성 / Create config
     *
     * @tags Admin - Management
     * @name AdminManagementControllerCreateConfig
     * @summary Create config
     * @request POST:/api/admin/configs
     * @secure
     */
    adminManagementControllerCreateConfig: (
      data: CreateConfigDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/admin/configs`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 키로 설정 조회 / Get config by key
     *
     * @tags Admin - Management
     * @name AdminManagementControllerGetConfigByKey
     * @summary Get config by key
     * @request GET:/api/admin/configs/{key}
     * @secure
     */
    adminManagementControllerGetConfigByKey: (
      key: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/admin/configs/${key}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description 설정 수정 / Update config
     *
     * @tags Admin - Management
     * @name AdminManagementControllerUpdateConfig
     * @summary Update config
     * @request PUT:/api/admin/configs/{key}
     * @secure
     */
    adminManagementControllerUpdateConfig: (
      key: string,
      data: UpdateConfigDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/admin/configs/${key}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 설정 삭제 / Delete config
     *
     * @tags Admin - Management
     * @name AdminManagementControllerDeleteConfig
     * @summary Delete config
     * @request DELETE:/api/admin/configs/{key}
     * @secure
     */
    adminManagementControllerDeleteConfig: (
      key: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/admin/configs/${key}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description 로그 검색 / Search logs
     *
     * @tags Admin - Management
     * @name AdminManagementControllerSearchLogs
     * @summary Search logs
     * @request GET:/api/admin/logs
     * @secure
     */
    adminManagementControllerSearchLogs: (
      query?: {
        /** User ID */
        userId?: string;
        /** Experiment Key */
        experimentKey?: string;
        /**
         * Page number
         * @default 1
         */
        page?: number;
        /**
         * Page size
         * @default 50
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/admin/logs`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 엑셀 다운로드할 로그 개수 조회 / Get export logs count
     *
     * @tags Admin - Management
     * @name AdminManagementControllerGetExportLogsCount
     * @summary Get export logs count
     * @request GET:/api/admin/logs/export/count
     * @secure
     */
    adminManagementControllerGetExportLogsCount: (
      query?: {
        /** User ID */
        userId?: string;
        /** Experiment Key */
        experimentKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/admin/logs/export/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 로그 엑셀 다운로드 / Export logs to Excel
     *
     * @tags Admin - Management
     * @name AdminManagementControllerExportLogs
     * @summary Export logs to Excel
     * @request GET:/api/admin/logs/export
     * @secure
     */
    adminManagementControllerExportLogs: (
      query?: {
        /** User ID */
        userId?: string;
        /** Experiment Key */
        experimentKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/admin/logs/export`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description experimentKey 기준 로그 삭제 / Delete logs by experimentKey
     *
     * @tags Admin - Management
     * @name AdminManagementControllerDeleteLogsByExperimentKey
     * @summary Delete logs by experimentKey
     * @request DELETE:/api/admin/logs/{experimentKey}
     * @secure
     */
    adminManagementControllerDeleteLogsByExperimentKey: (
      experimentKey: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/admin/logs/${experimentKey}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description 이미지 로그 검색 / Search image logs
     *
     * @tags Admin - Management
     * @name AdminManagementControllerSearchImageLogs
     * @summary Search image logs
     * @request GET:/api/admin/image-logs
     * @secure
     */
    adminManagementControllerSearchImageLogs: (
      query?: {
        /** User ID */
        userId?: string;
        /** Experiment Key */
        experimentKey?: string;
        /**
         * Page number
         * @default 1
         */
        page?: number;
        /**
         * Page size
         * @default 50
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/admin/image-logs`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 엑셀 다운로드할 이미지 로그 개수 조회 / Get export image logs count
     *
     * @tags Admin - Management
     * @name AdminManagementControllerGetExportImageLogsCount
     * @summary Get export image logs count
     * @request GET:/api/admin/image-logs/export/count
     * @secure
     */
    adminManagementControllerGetExportImageLogsCount: (
      query?: {
        /** User ID */
        userId?: string;
        /** Experiment Key */
        experimentKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/admin/image-logs/export/count`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 이미지 로그 엑셀 다운로드 / Export image logs to Excel
     *
     * @tags Admin - Management
     * @name AdminManagementControllerExportImageLogs
     * @summary Export image logs to Excel
     * @request GET:/api/admin/image-logs/export
     * @secure
     */
    adminManagementControllerExportImageLogs: (
      query?: {
        /** User ID */
        userId?: string;
        /** Experiment Key */
        experimentKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/admin/image-logs/export`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description experimentKey 기준 이미지 로그 삭제 / Delete image logs by experimentKey
     *
     * @tags Admin - Management
     * @name AdminManagementControllerDeleteImageLogsByExperimentKey
     * @summary Delete image logs by experimentKey
     * @request DELETE:/api/admin/image-logs/{experimentKey}
     * @secure
     */
    adminManagementControllerDeleteImageLogsByExperimentKey: (
      experimentKey: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/admin/image-logs/${experimentKey}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description 대시보드 전체 통계 조회 / Get dashboard statistics
     *
     * @tags Admin - Management
     * @name AdminManagementControllerGetDashboardStats
     * @summary Get dashboard statistics
     * @request GET:/api/admin/dashboard/stats
     * @secure
     */
    adminManagementControllerGetDashboardStats: (params: RequestParams = {}) =>
      this.request<DashboardStatsDto, any>({
        path: `/api/admin/dashboard/stats`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 기간별 로그 통계 조회 / Get log statistics by date range
     *
     * @tags Admin - Management
     * @name AdminManagementControllerGetLogStatsByDateRange
     * @summary Get log statistics by date range
     * @request GET:/api/admin/dashboard/logs-by-date
     * @secure
     */
    adminManagementControllerGetLogStatsByDateRange: (
      query?: {
        /** Number of days (default: 7) */
        days?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<LogStatsByDateDto[], any>({
        path: `/api/admin/dashboard/logs-by-date`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 상위 사용자 통계 조회 / Get top users statistics
     *
     * @tags Admin - Management
     * @name AdminManagementControllerGetTopUsers
     * @summary Get top users statistics
     * @request GET:/api/admin/dashboard/top-users
     * @secure
     */
    adminManagementControllerGetTopUsers: (
      query?: {
        /** Number of users (default: 5) */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TopUserStatsDto[], any>({
        path: `/api/admin/dashboard/top-users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 상위 실험 키 통계 조회 / Get top experiment keys statistics
     *
     * @tags Admin - Management
     * @name AdminManagementControllerGetTopExperimentKeys
     * @summary Get top experiment keys statistics
     * @request GET:/api/admin/dashboard/top-experiment-keys
     * @secure
     */
    adminManagementControllerGetTopExperimentKeys: (
      query?: {
        /** Number of experiment keys (default: 5) */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TopExperimentKeyStatsDto[], any>({
        path: `/api/admin/dashboard/top-experiment-keys`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 토큰 사용량 통계 조회 / Get token usage statistics
     *
     * @tags Admin - Management
     * @name AdminManagementControllerGetTokenUsageStats
     * @summary Get token usage statistics
     * @request GET:/api/admin/dashboard/token-usage
     * @secure
     */
    adminManagementControllerGetTokenUsageStats: (params: RequestParams = {}) =>
      this.request<TokenUsageStatsDto, any>({
        path: `/api/admin/dashboard/token-usage`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 최근 활동 조회 / Get recent activity
     *
     * @tags Admin - Management
     * @name AdminManagementControllerGetRecentActivity
     * @summary Get recent activity
     * @request GET:/api/admin/dashboard/recent-activity
     * @secure
     */
    adminManagementControllerGetRecentActivity: (
      query?: {
        /** Number of activities (default: 10) */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<RecentActivityDto[], any>({
        path: `/api/admin/dashboard/recent-activity`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description KPC 설정을 사용한 텍스트 생성 (멀티모달 지원) / Generate text using KPC database configuration with multimodal support
     *
     * @tags KPC - Production Text Generation
     * @name KpcControllerGenerateText
     * @summary Generate text using KPC configuration
     * @request POST:/api/kpc/text-generation
     */
    kpcControllerGenerateText: (
      data: TextGenerationDto,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          message?: string;
          data?: {
            generatedText?: string;
            /** List of successfully processed image URLs */
            processedImageUrls?: string[];
            metadata?: {
              accountId?: string;
              accountNumber?: number;
              duration?: string;
              prompt?: string;
              maxTokens?: number;
              temperature?: number;
              topP?: number;
              model?: string;
              region?: string;
              accessKeyId?: string;
              responseLength?: number;
              userId?: string;
              tokenUsage?: {
                inputTokens?: number;
                outputTokens?: number;
                totalTokens?: number;
              } | null;
            };
          };
        },
        void
      >({
        path: `/api/kpc/text-generation`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description KPC 설정을 사용한 SSE 스트리밍 텍스트 생성 (멀티모달 지원) / Generate text using KPC database configuration with SSE streaming and multimodal support
     *
     * @tags KPC - Production Text Generation
     * @name KpcControllerGenerateTextStreamSse
     * @summary Generate text using KPC configuration with SSE streaming
     * @request POST:/api/kpc/text-generation/stream
     */
    kpcControllerGenerateTextStreamSse: (
      data: TextGenerationDto,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/api/kpc/text-generation/stream`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description KPC 설정을 사용한 이미지 생성 및 S3 저장 / Generate image using KPC database configuration and save to S3
     *
     * @tags KPC - Production Text Generation
     * @name KpcControllerGenerateImage
     * @summary Generate image using KPC configuration
     * @request POST:/api/kpc/image-generation
     */
    kpcControllerGenerateImage: (
      data: ImageGenerationDto,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          message?: string;
          data?: {
            /** CDN URL of generated image */
            imageUrl?: string;
            /** S3 object key */
            s3Key?: string;
            metadata?: {
              accountId?: string;
              accountNumber?: number;
              duration?: string;
              prompt?: string;
              width?: number;
              height?: number;
              cfgScale?: number;
              numberOfImages?: number;
              quality?: string;
              model?: string;
              region?: string;
              accessKeyId?: string;
              imageSize?: string;
              attempt?: number;
              totalAttempts?: number;
              userId?: string;
              folderPath?: string;
            };
          };
        },
        void
      >({
        path: `/api/kpc/image-generation`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description S3에 파일 업로드 (텍스트 파일 및 이미지 파일 지원) / Upload file to S3 storage (supports text and image files)
     *
     * @tags KPC - Production Text Generation
     * @name KpcControllerUploadFile
     * @summary Upload file to S3
     * @request POST:/api/kpc/file-upload
     */
    kpcControllerUploadFile: (
      data: {
        /**
         * File to upload (text files: TXT, CSV, JSON, XML or image files: PNG, JPEG, JPG)
         * @format binary
         */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          message?: string;
          data?: {
            /** CDN URL of uploaded file */
            url?: string;
            /** S3 object key */
            key?: string;
            /** File size in bytes */
            size?: number;
            /** Original filename */
            originalName?: string;
            /** MIME type */
            contentType?: string;
            /** Upload timestamp */
            uploadedAt?: string;
            /** File type (text or image) */
            fileType?: string;
          };
        },
        void
      >({
        path: `/api/kpc/file-upload`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description 한국어 텍스트를 영어로 번역 / Translate Korean text to English using KPC configuration
     *
     * @tags KPC - Production Text Generation
     * @name KpcControllerTranslateKoToEn
     * @summary Translate Korean text to English
     * @request POST:/api/kpc/translate/ko-to-en
     */
    kpcControllerTranslateKoToEn: (
      data: TranslateKoToEnDto,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          message?: string;
          data?: {
            /** Translated English text */
            translatedText?: string;
            metadata?: {
              accountId?: string;
              accountNumber?: number;
              duration?: string;
              originalText?: string;
              translatedText?: string;
              maxTokens?: number;
              temperature?: number;
              topP?: number;
              model?: string;
              region?: string;
              accessKeyId?: string;
              responseLength?: number;
              userId?: string;
              tokenUsage?: {
                inputTokens?: number;
                outputTokens?: number;
                totalTokens?: number;
              } | null;
            };
          };
        },
        void
      >({
        path: `/api/kpc/translate/ko-to-en`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description S3 연결 및 자격 증명 테스트 / Test S3 connection and credentials
     *
     * @tags KPC - Production Text Generation
     * @name KpcControllerTestS3Connection
     * @summary Test S3 connection
     * @request POST:/api/kpc/s3-test
     */
    kpcControllerTestS3Connection: (params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          message?: string;
          data?: {
            success?: boolean;
            message?: string;
            details?: object;
          };
        },
        void
      >({
        path: `/api/kpc/s3-test`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description 이미지 다운로드 프록시 / Download image via proxy to avoid CORS issues
     *
     * @tags KPC - Production Text Generation
     * @name KpcControllerDownloadImage
     * @summary Download image via proxy
     * @request GET:/api/kpc/download-image
     */
    kpcControllerDownloadImage: (
      query: {
        url: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<File, any>({
        path: `/api/kpc/download-image`,
        method: "GET",
        query: query,
        format: "blob",
        ...params,
      }),

    /**
     * @description 문자 제한 설정 조회 / Get character limits configuration
     *
     * @tags KPC - Production Text Generation
     * @name KpcControllerGetCharacterLimits
     * @summary Get character limits configuration
     * @request GET:/api/kpc/config/limits
     */
    kpcControllerGetCharacterLimits: (params: RequestParams = {}) =>
      this.request<ConfigLimitsDto, any>({
        path: `/api/kpc/config/limits`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Gemini 모델을 사용한 텍스트 생성 (멀티모달 지원) / Generate text using Gemini model with multimodal support
     *
     * @tags KPC V2 - Google Gemini/Imagen
     * @name KpcV2ControllerGenerateText
     * @summary Generate text using Gemini
     * @request POST:/api/v2/kpc/text-generation
     */
    kpcV2ControllerGenerateText: (
      data: TextGenerationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v2/kpc/text-generation`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 부하 테스트용 비스트리밍 텍스트 생성 / Non-streaming text generation for load testing
     *
     * @tags KPC V2 - Google Gemini/Imagen
     * @name KpcV2ControllerGenerateTextNoStream
     * @summary Generate text using Gemini (no streaming, for load testing)
     * @request POST:/api/v2/kpc/text-generation/no-stream
     */
    kpcV2ControllerGenerateTextNoStream: (
      data: TextGenerationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v2/kpc/text-generation/no-stream`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Gemini 모델을 사용한 SSE 스트리밍 텍스트 생성 (멀티모달 지원)
     *
     * @tags KPC V2 - Google Gemini/Imagen
     * @name KpcV2ControllerGenerateTextStream
     * @summary Generate text using Gemini with SSE streaming
     * @request POST:/api/v2/kpc/text-generation/stream
     */
    kpcV2ControllerGenerateTextStream: (
      data: TextGenerationDto,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v2/kpc/text-generation/stream`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Imagen 모델을 사용한 이미지 생성 및 S3 저장
     *
     * @tags KPC V2 - Google Gemini/Imagen
     * @name KpcV2ControllerGenerateImage
     * @summary Generate image using Imagen
     * @request POST:/api/v2/kpc/image-generation
     */
    kpcV2ControllerGenerateImage: (
      data: ImageGenerationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v2/kpc/image-generation`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description S3에 파일 업로드 (텍스트 파일 및 이미지 파일 지원)
     *
     * @tags KPC V2 - Google Gemini/Imagen
     * @name KpcV2ControllerUploadFile
     * @summary Upload file to S3
     * @request POST:/api/v2/kpc/file-upload
     */
    kpcV2ControllerUploadFile: (
      data: {
        /** @format binary */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v2/kpc/file-upload`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * @description 이미지 다운로드 프록시 / Download image via proxy to avoid CORS issues
     *
     * @tags KPC V2 - Google Gemini/Imagen
     * @name KpcV2ControllerDownloadImage
     * @summary Download image via proxy
     * @request GET:/api/v2/kpc/download-image
     */
    kpcV2ControllerDownloadImage: (
      query: {
        url: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v2/kpc/download-image`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description 문자 제한 설정 조회
     *
     * @tags KPC V2 - Google Gemini/Imagen
     * @name KpcV2ControllerGetCharacterLimits
     * @summary Get character limits configuration
     * @request GET:/api/v2/kpc/config/limits
     */
    kpcV2ControllerGetCharacterLimits: (params: RequestParams = {}) =>
      this.request<ConfigLimitsDto, any>({
        path: `/api/v2/kpc/config/limits`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  chatV2 = {
    /**
     * @description 새로운 채팅 세션을 생성합니다
     *
     * @tags Chat V2 - Google Gemini
     * @name ChatV2ControllerCreateSession
     * @summary Create new chat session
     * @request POST:/chat-v2/sessions
     */
    chatV2ControllerCreateSession: (
      data: CreateChatSessionDto,
      params: RequestParams = {},
    ) =>
      this.request<ApiResponseDto, any>({
        path: `/chat-v2/sessions`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 사용자의 채팅 세션 목록을 조회합니다
     *
     * @tags Chat V2 - Google Gemini
     * @name ChatV2ControllerGetUserSessions
     * @summary Get user chat sessions
     * @request GET:/chat-v2/sessions
     */
    chatV2ControllerGetUserSessions: (
      query?: {
        /**
         * 페이지 번호 / Page number
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * 페이지당 항목 수 / Items per page
         * @min 1
         * @max 100
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedResponseDto, any>({
        path: `/chat-v2/sessions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description ID로 채팅 세션을 조회합니다
     *
     * @tags Chat V2 - Google Gemini
     * @name ChatV2ControllerGetSession
     * @summary Get chat session by ID
     * @request GET:/chat-v2/sessions/{id}
     */
    chatV2ControllerGetSession: (id: string, params: RequestParams = {}) =>
      this.request<ApiResponseDto, any>({
        path: `/chat-v2/sessions/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 채팅 세션을 삭제합니다
     *
     * @tags Chat V2 - Google Gemini
     * @name ChatV2ControllerDeleteSession
     * @summary Delete chat session
     * @request DELETE:/chat-v2/sessions/{id}
     */
    chatV2ControllerDeleteSession: (id: string, params: RequestParams = {}) =>
      this.request<ApiResponseDto, any>({
        path: `/chat-v2/sessions/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description 채팅에 메시지를 전송합니다 (Gemini 기반 응답)
     *
     * @tags Chat V2 - Google Gemini
     * @name ChatV2ControllerSendMessage
     * @summary Send message to chat
     * @request POST:/chat-v2/messages
     */
    chatV2ControllerSendMessage: (
      data: SendMessageDto,
      params: RequestParams = {},
    ) =>
      this.request<ApiResponseDto, any>({
        path: `/chat-v2/messages`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Gemini 모델과 JSON 형식으로 채팅합니다
     *
     * @tags Chat V2 - Google Gemini
     * @name ChatV2ControllerChatWithGemini
     * @summary Gemini Chat - direct JSON-based chat
     * @request POST:/chat-v2/api/chat
     */
    chatV2ControllerChatWithGemini: (
      data: ChatRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<ChatResponseDto, void>({
        path: `/chat-v2/api/chat`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 텍스트 및 이미지 파일을 포함한 Gemini 채팅 (멀티모달 지원)
     *
     * @tags Chat V2 - Google Gemini
     * @name ChatV2ControllerChatWithFileUpload
     * @summary Gemini Chat with File Upload
     * @request POST:/chat-v2/api/chat/upload
     */
    chatV2ControllerChatWithFileUpload: (
      data: {
        /**
         * JSON string of chat messages array
         * @example "[{"role":"user","content":"이미지를 분석해주세요"}]"
         */
        messages: string;
        /** @example 8196 */
        maxTokens?: number;
        /** @example 0.5 */
        temperature?: number;
        /** @example 0.9 */
        topP?: number;
        /**
         * Optional file upload (text/plain, image/jpeg, image/png)
         * @format binary
         */
        file?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChatResponseDto, void>({
        path: `/chat-v2/api/chat/upload`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),
  };
}
